export function contentValidator(source: string, customMarkdownTags: string[]) {
  const invalidOpeningTags = {
    "<linkToModal": "<LinkToModal",
    "<modalFromLink": "<ModalFromLink",
    "<calloutBox": "<CalloutBox",
    "<emptyBr": "<EmptyBr"
  }
  customMarkdownTags.forEach((markdownTag) => {
    const openingCarat = "<"
    const downCasedMarkdownTag = markdownTag.charAt(0).toLowerCase() + markdownTag.slice(1)
    invalidOpeningTags[openingCarat + downCasedMarkdownTag] = openingCarat + markdownTag
  })
  let validatedSource = source

  Object.keys(invalidOpeningTags).forEach((invalidTag) =>
    validatedSource.includes(invalidTag)
      ? (validatedSource = validatedSource.replace(invalidTag, invalidOpeningTags[invalidTag]))
      : null
  )
  return validatedSource
}
